/* ==========================================================================
   Category Carousel
   - Setas prev/next com scroll suave
   - Drag-to-scroll (mouse) + swipe nativo (touch)
   - Atualiza estado das setas conforme a posição
   - Suporta múltiplas instâncias na mesma página
   ========================================================================== */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.ccInit === 'true') return;
    root.dataset.ccInit = 'true';

    var track = root.querySelector('[data-cc-track]');
    var prevBtn = root.querySelector('[data-cc-prev]');
    var nextBtn = root.querySelector('[data-cc-next]');
    if (!track) return;

    function scrollAmount() {
      var item = track.querySelector('.category-carousel__item');
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24', 10) || 24;
      var itemWidth = item ? item.getBoundingClientRect().width : track.clientWidth / 2;
      // Avança ~ a largura visível, alinhado por card
      var perView = Math.max(1, Math.round(track.clientWidth / (itemWidth + gap)));
      return (itemWidth + gap) * perView;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll;
      var hasOverflow = track.scrollWidth > track.clientWidth + 2;

      if (prevBtn) {
        prevBtn.disabled = atStart || !hasOverflow;
        prevBtn.setAttribute('tabindex', atStart || !hasOverflow ? '-1' : '0');
      }
      if (nextBtn) {
        nextBtn.disabled = atEnd || !hasOverflow;
        nextBtn.setAttribute('tabindex', atEnd || !hasOverflow ? '-1' : '0');
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    // ----- Drag to scroll (ponteiro) ---------------------------------------
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      // Apenas mouse/caneta; toque usa scroll nativo
      if (e.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('is-dragging');
        if (track.setPointerCapture && e.pointerId != null) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (moved) track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      updateArrows();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    // Impede que o clique acidental após arrastar navegue para o link
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    // ----- Listeners de estado ---------------------------------------------
    var rafId = null;
    track.addEventListener(
      'scroll',
      function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          updateArrows();
          rafId = null;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cc-root]');
    roots.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Suporte ao editor de temas do Shopify (recarrega seção)
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();